var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Polaris-Layout__AnnotatedSection"
  }, [_c('div', {
    staticClass: "Polaris-Layout__AnnotationWrapper"
  }, [_c('div', {
    staticClass: "Polaris-Layout__Annotation"
  }, [_c('polaris-text-container', [_c('polaris-heading', {
    attrs: {
      "tag": "h2"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.title) + "\n                ")]), _vm._v(" "), (_vm.description) ? _c('p', [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _vm._v(" "), _vm._t("description")], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "Polaris-Layout__AnnotationContent"
  }, [_vm._t("default")], 2)])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d86e296", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d86e296","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisLayoutAnnotatedSection.vue
// module id = 359
// module chunks = 0